import { render, staticRenderFns } from "./PageNumber.vue?vue&type=template&id=c59addfa"
import script from "./PageNumber.vue?vue&type=script&lang=js"
export * from "./PageNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports